import { generateChart } from "./chartComponentGenerator";

export const chartImageMap = {
"Pie_Chart": "Pie_Chart.png",
"Advanced_Pie_Chart":"Advanced_Pie_Chart.png",
"Pie_Grid":"Pie_Grid.png",
"tree-map":"tree-map.png",
"number-card":"number-card.png",
"gauge":"gauge.png",
"Vertical_Bar_Chart":"Vertical_Bar_Chart.png",
"Horizontal_Bar_Chart":"Horizontal_Bar_Chart.png",
"Grouped_Vertical_Bar_Chart":"Grouped_Vertical_Bar_Chart.png",
"Grouped_Horizontal_Bar_Chart":"Grouped_Horizontal_Bar_Chart.png",
"Stacked_Vertical_Bar_Chart":"Stacked_Vertical_Bar_Chart.png",
"Stacked_Horizontal_Bar_Chart": "Stacked_Horizontal_Bar_Chart.png",
"Normalized_Vertical_Bar_Chart":"Normalized_Vertical_Bar_Chart.png",
"Normalized_Horizontal_Bar_Chart":"Normalized_Horizontal_Bar_Chart.png",
"line-chart":"line-chart.png",
"polar-chart":"polar-chart.png",
"area-chart":"area-chart.png",
"area-chart-stacked": "area-chart-stacked.png",
"area-chart-normalized": "area-chart-normalized.png",
"heat-map":"heat-map.png",
"box-chart": "box-chart.png",
Calendar:"Calendar.png",
Timeline:"Timeline.png"


}
export const chartNameeMap = {
"Pie_Chart": "Pie",
"Advanced_Pie_Chart":"Advanced",
"Pie_Grid":"Grid",
"tree-map":"TreeMap",
"number-card":"Score",
"gauge":"Gauge",
"Vertical_Bar_Chart":"Bar Vertical",
"Horizontal_Bar_Chart":"Bar Horizontal",
"Grouped_Vertical_Bar_Chart":"V Group Bar",
"Grouped_Horizontal_Bar_Chart":"H Group Bar",
"Stacked_Vertical_Bar_Chart":"Stacked Vertical",
"Stacked_Horizontal_Bar_Chart": "Stacked Horizontal",
"Normalized_Vertical_Bar_Chart":"Vertical Normalized",
"Normalized_Horizontal_Bar_Chart":"Horizontal Normalized",
"line-chart":"Line",
"polar-chart":"Polar",
"area-chart":"Area",
"area-chart-stacked": "Atacked Area",
"area-chart-normalized": "Normalized Area",
"heat-map":"Heat Map",
"box-chart": "Box",
Calendar:"Calendar",
Timeline:"Timeline"

}
export function getChartPreview(variant: any, modelName: string, searchableFields:any) {
  const component = generateChart(variant, modelName, searchableFields);
  const chartTemplate = getTempTemplate(component);
  return getTempSchemna(chartTemplate, modelName);
}
export function getTempSchemna(template: any, modelName: string) {
  return {
    identifierKey:
      '{"versionId":1,"id":660,"uuid":"294a4597-d83b-4edd-b1fe-6dfb86738382"}',
    id: 660,
    versionId: 1,
    createdBy: 1,
    lastUpdatedBy: 320,
    createdOn: "2023-03-03T11:02:56.000+05:30",
    lastUpdatedOn: "2023-11-22T11:59:52.099+05:30",
    activeCode: "ACTV",
    statusCode: "APPROVED",
    typeCode: "HRMS",
    subTypeCode: modelName,
    uuid: crypto.randomUUID,
    name: "",
    template: JSON.stringify(template),
    referenceId: "LAY20230303660",
    category: "CaseBuilder",
    stageCode: "INITIATION",
    isMasterVersion: true,
    applicantPartyCode: "FGGROUP",
    templateHash: "99f8b9bfa3b5de407ab11ac3a5ea039b",
    masterContentHash: "99f8b9bfa3b5de407ab11ac3a5ea039b",
    versionNo: 8,
  };
}

export function getTempTemplate(chart: any) {
  //console.log("this chart :", chart);
  const tmpChart = {
    type: "fgchart",
    subtype: "pie",
    cat: "chart",
    icon: "  fa fa-pie-chart",
    name: "Pie Chart",
    options: { legend: {} },
    condition: {},
    isCoreConfig: true,
    category: "BLOCKS",
    uuid: "3afda91c-da5c-49c2-b856-367129b62356",
    noDataMessage: { messageIcon: "", messageHeader: "", messageBody: "" },
    queryConfig: {
      measureField: [
        {
          tag: "Project",
          name: "PARTNER",
          type: "text",
          displayName: "Partner",
          description: null,
          defaultValue: null,
          systemDefined: null,
          isEditable: null,
          isSearchable: null,
          isGroupable: null,
          isSortable: null,
          isAuditable: null,
          isWorkflowEnabled: null,
          minLength: 0,
          maxLength: 100,
          isUnique: null,
          isMandatory: false,
          isPrimaryKey: false,
          isLink: null,
          pattern: null,
          prefix: null,
          suffix: null,
          isMesurable: true,
          isDimensional: true,
          isParty: null,
          lookUpReference: {
            lookupCode: null,
            filterField: null,
            filterValue: null,
            displayField: null,
            valueField: null,
            defaultValue: null,
            dataSourceValues: null,
            filtersList: null,
            isCustomService: null,
            customServiceBean: null,
            customServiceMethod: null,
            datasetId: null,
            lookupPage: null,
            roles: null,
          },
          fieldType: "ENTITY",
          filterLookUpReference: {
            lookupCode: null,
            filterField: null,
            filterValue: null,
            displayField: "",
            valueField: "",
            defaultValue: null,
            dataSourceValues: null,
            filtersList: null,
            isCustomService: null,
            customServiceBean: null,
            customServiceMethod: null,
            datasetId: null,
            lookupPage: null,
            roles: null,
          },
          fieldTypeKey: "BS_PARTNER",
          isAuthflowEnabled: null,
          isSecured: null,
          translationFieldCode: "PARTNER_NAME",
          isNonPersistField: null,
          isConfirmationField: null,
          isAcknowledgementField: null,
          identifierKey: null,
          authflowResolver: null,
          weight: 0,
          isIndexing: null,
          modelCode: "BS_PROJECTS",
          isFreeText: null,
          isFacet: null,
          securityType: null,
          encryptionType: null,
          algorithm: null,
          persistWithMasking: null,
          maskChar: null,
          maskStart: null,
          maskEnd: null,
          isEncryptionEnabled: null,
          translationValueField: "REFERENCE_ID",
          translationDisplayField: "NAME",
          isDynamicField: null,
          dynamicFieldExpression: null,
          isObjectSecurity: null,
          expressionLanguage: null,
          dateFormatToken: null,
          referenceGenCode: null,
          maxDigit: null,
          seedValue: null,
          deferIdGenerate: null,
          defaultAsUuid: null,
          isMultiSelect: null,
          virtualFieldExpression: null,
          virtualFieldPattern: null,
          lineColor: {},
          fillColor: {},
        },
      ],
      measureFieldAggregation: "count",
      model: "BS_PROJECTS",
      dimensionField: [
        {
          tag: "Project",
          name: "PARTNER",
          type: "text",
          displayName: "Partner",
          description: null,
          defaultValue: null,
          systemDefined: null,
          isEditable: null,
          isSearchable: null,
          isGroupable: null,
          isSortable: null,
          isAuditable: null,
          isWorkflowEnabled: null,
          minLength: 0,
          maxLength: 100,
          isUnique: null,
          isMandatory: false,
          isPrimaryKey: false,
          isLink: null,
          pattern: null,
          prefix: null,
          suffix: null,
          isMesurable: true,
          isDimensional: true,
          isParty: null,
          lookUpReference: {
            lookupCode: null,
            filterField: null,
            filterValue: null,
            displayField: null,
            valueField: null,
            defaultValue: null,
            dataSourceValues: null,
            filtersList: null,
            isCustomService: null,
            customServiceBean: null,
            customServiceMethod: null,
            datasetId: null,
            lookupPage: null,
            roles: null,
          },
          fieldType: "ENTITY",
          filterLookUpReference: {
            lookupCode: null,
            filterField: null,
            filterValue: null,
            displayField: "",
            valueField: "",
            defaultValue: null,
            dataSourceValues: null,
            filtersList: null,
            isCustomService: null,
            customServiceBean: null,
            customServiceMethod: null,
            datasetId: null,
            lookupPage: null,
            roles: null,
          },
          fieldTypeKey: "BS_PARTNER",
          isAuthflowEnabled: null,
          isSecured: null,
          translationFieldCode: "PARTNER_NAME",
          isNonPersistField: null,
          isConfirmationField: null,
          isAcknowledgementField: null,
          identifierKey: null,
          authflowResolver: null,
          weight: 0,
          isIndexing: null,
          modelCode: "BS_PROJECTS",
          isFreeText: null,
          isFacet: null,
          securityType: null,
          encryptionType: null,
          algorithm: null,
          persistWithMasking: null,
          maskChar: null,
          maskStart: null,
          maskEnd: null,
          isEncryptionEnabled: null,
          translationValueField: "REFERENCE_ID",
          translationDisplayField: "NAME",
          isDynamicField: null,
          dynamicFieldExpression: null,
          isObjectSecurity: null,
          expressionLanguage: null,
          dateFormatToken: null,
          referenceGenCode: null,
          maxDigit: null,
          seedValue: null,
          deferIdGenerate: null,
          defaultAsUuid: null,
          isMultiSelect: null,
          virtualFieldExpression: null,
          virtualFieldPattern: null,
        },
      ],
    },
    pagination: {},
    customColorScheme: "#964B00,#C46200,#F27900,#FF9021,#FFA74F,#FFFFFF",
    chartSubtype: "Pie_Chart",
    isXAxisLabel: "Partner",
    isChartTheme: "Light",
    enableColor: true,
    colorScheme: {
      code: "natural",
      title: "natural",
      value: [
        "#bf9d76",
        "#e99450",
        "#d89f59",
        "#f2dfa7",
        "#a5d7c6",
        "#7794b1",
        "#afafaf",
        "#707160",
        "#ba9383",
        "#d9d5c3",
      ],
    },
  };
  const tmpChart2 = {
    type: "fgchart",
    subtype: "pie",
    cat: "chart",
    icon: "  fa fa-pie-chart",
    name: "advancedPieChartByname_name",
    options: { legend: {} },
    condition: {},
    uuid: "f909f4e3-3fb7-499c-b06c-68b0de375754",
    queryConfig: {
      model: "BS_PROJECTS",
      measureFieldAggregation: "count",
      measureField: [
        {
          tag: "Project",
          name: "NAME",
          type: "text",
          displayName: "Name",
          description: null,
          defaultValue: null,
          systemDefined: null,
          isEditable: null,
          isSearchable: null,
          isGroupable: null,
          isSortable: null,
          isAuditable: null,
          isWorkflowEnabled: null,
          minLength: 0,
          maxLength: 255,
          isUnique: null,
          isMandatory: true,
          isPrimaryKey: false,
          isLink: null,
          pattern: null,
          prefix: null,
          suffix: null,
          isMesurable: true,
          isDimensional: true,
          isParty: null,
          lookUpReference: {
            lookupCode: null,
            filterField: null,
            filterValue: null,
            displayField: null,
            valueField: null,
            defaultValue: null,
            dataSourceValues: null,
            filtersList: null,
            isCustomService: null,
            customServiceBean: null,
            customServiceMethod: null,
            datasetId: null,
            lookupPage: null,
            roles: null,
          },
          fieldType: null,
          filterLookUpReference: {
            lookupCode: null,
            filterField: null,
            filterValue: null,
            displayField: null,
            valueField: null,
            defaultValue: null,
            dataSourceValues: null,
            filtersList: null,
            isCustomService: null,
            customServiceBean: null,
            customServiceMethod: null,
            datasetId: null,
            lookupPage: null,
            roles: null,
          },
          fieldTypeKey: null,
          isAuthflowEnabled: null,
          isSecured: null,
          translationFieldCode: null,
          isNonPersistField: null,
          isConfirmationField: null,
          isAcknowledgementField: null,
          identifierKey: null,
          authflowResolver: null,
          weight: 0,
          isIndexing: null,
          modelCode: "BS_PROJECTS",
          isFreeText: null,
          isFacet: null,
          securityType: null,
          encryptionType: null,
          algorithm: null,
          persistWithMasking: null,
          maskChar: null,
          maskStart: null,
          maskEnd: null,
          isEncryptionEnabled: null,
          translationValueField: null,
          translationDisplayField: null,
          isDynamicField: null,
          dynamicFieldExpression: null,
          isObjectSecurity: null,
          expressionLanguage: null,
          dateFormatToken: null,
          referenceGenCode: null,
          maxDigit: null,
          seedValue: null,
          deferIdGenerate: null,
          defaultAsUuid: null,
          isMultiSelect: null,
          virtualFieldExpression: null,
          virtualFieldPattern: null,
        },
      ],
      dimensionField: [
        {
          tag: "Project",
          name: "NAME",
          type: "text",
          displayName: "Name",
          description: null,
          defaultValue: null,
          systemDefined: null,
          isEditable: null,
          isSearchable: null,
          isGroupable: null,
          isSortable: null,
          isAuditable: null,
          isWorkflowEnabled: null,
          minLength: 0,
          maxLength: 255,
          isUnique: null,
          isMandatory: true,
          isPrimaryKey: false,
          isLink: null,
          pattern: null,
          prefix: null,
          suffix: null,
          isMesurable: true,
          isDimensional: true,
          isParty: null,
          lookUpReference: {
            lookupCode: null,
            filterField: null,
            filterValue: null,
            displayField: null,
            valueField: null,
            defaultValue: null,
            dataSourceValues: null,
            filtersList: null,
            isCustomService: null,
            customServiceBean: null,
            customServiceMethod: null,
            datasetId: null,
            lookupPage: null,
            roles: null,
          },
          fieldType: null,
          filterLookUpReference: {
            lookupCode: null,
            filterField: null,
            filterValue: null,
            displayField: null,
            valueField: null,
            defaultValue: null,
            dataSourceValues: null,
            filtersList: null,
            isCustomService: null,
            customServiceBean: null,
            customServiceMethod: null,
            datasetId: null,
            lookupPage: null,
            roles: null,
          },
          fieldTypeKey: null,
          isAuthflowEnabled: null,
          isSecured: null,
          translationFieldCode: null,
          isNonPersistField: null,
          isConfirmationField: null,
          isAcknowledgementField: null,
          identifierKey: null,
          authflowResolver: null,
          weight: 0,
          isIndexing: null,
          modelCode: "BS_PROJECTS",
          isFreeText: null,
          isFacet: null,
          securityType: null,
          encryptionType: null,
          algorithm: null,
          persistWithMasking: null,
          maskChar: null,
          maskStart: null,
          maskEnd: null,
          isEncryptionEnabled: null,
          translationValueField: null,
          translationDisplayField: null,
          isDynamicField: null,
          dynamicFieldExpression: null,
          isObjectSecurity: null,
          expressionLanguage: null,
          dateFormatToken: null,
          referenceGenCode: null,
          maxDigit: null,
          seedValue: null,
          deferIdGenerate: null,
          defaultAsUuid: null,
          isMultiSelect: null,
          virtualFieldExpression: null,
          virtualFieldPattern: null,
        },
      ],
      conditions: [],
      dateField: [],
    },
    noDataMessage: {},
    isHeading: true,
    collapsed: false,
    fullscreen: false,
    heading: "Name vs Name",
    isOptionChart: "Advanced_Pie_Chart",
    isChartTheme: "Light",
    isShowXAxis: true,
    isShowYAxis: true,
    isShowLabels: true,
    AMOUNT: "Amount",
    isExplodeSlices: false,
    legendPosition: "right",
    enableColor: true,
    isChooseColor: "solar",
    enableDimensions: true,
    width: "1000",
    height: "400",
    enableOptions: true,
    legendTitle: "Legend Tittle",
    isDisableTooltip: false,
    isUseGradients: true,
    isAnimations: true,
    isDoughnut: false,
    colorScheme: { code: "CUSTOM", title: "Custom colors", value: [] },
    isShowXAxisLabel: true,
    isShowYAxisLabel: true,
    isShowLegend: true,
    arcWidth: 0.35,
    chartTheme: "Light",
    isXAxisLabel: "NAME",
    isYAxisLabel: "NAME",
    chartSubtype: "Advanced_Pie_Chart",
    wrapInCustomCard: false,
    isFullscreen: true,
    pagination: { range: "30" },
    customColorScheme: "var(--warning),var(--danger),var(--success)",
  };
  //console.log(" chart to be rendered ", chart);
  return {
    seoConfig: {
      seoTitleName: "Bar Charts",
    },
    selectedForm: {
      disableBuilderFunction: true,
    },
    forms: [
      {
        stageCode: "INITIATION",
        stageName: "Initiation",
        eventCode: "General",
        eventName: "Default",
        form: null,
        fgForm: [
          {
            type: "fgcontainer",
            uuid: "uuid001",
            children: [
              {
                type: "fgcustomcontainer",
                name: "Custom Container",
                icon: "fa fa-square-o",
                class: "card-default",
                header: true,
                heading: " some heading",
                config: true,
                children: [chart],
                condition: {},
                isCoreConfig: true,
                category: "LAYOUT",
                uuid: "833cfcdc-9476-40fa-89e4-66aec427d78f",
                parentContainer: true,
                displayContainer: "FORM_CONTAINER",
                styles: {},
              },
            ],
          },
        ],
      },
    ],
  };
}
